import type { Variant } from "./types";

export const VARIANTS = ["default", "default16", "default20"] as const;
export const DEFAULT_VARIANT = "default" satisfies Variant;
